import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import DeskTopBlueMobileWhiteHeader from "../../../../../components/sharedComponents/DeskTopBlueMobileWhiteHeader/DeskTopBlueMobileWhiteHeader";
import DetailsComponent from "../../SharedComponents/DetailsComponent/DetailsComponent";
import stl from "./TrackingCheckoutDetailsComponent.module.css";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { api__getOrderTrackingList } from "@/apis/orderTracking/api__getOrderTrackingList";
import useWebview from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
var TrackingCheckoutDetailsComponent = function TrackingCheckoutDetailsComponent(_ref) {
  var details = _ref.details,
    allOfferedDoc = _ref.allOfferedDoc,
    onRefreshOrder = _ref.onRefreshOrder;
  var webview = useWebview();
  var isCancelled = function isCancelled() {
    var _details$steps;
    return details === null || details === void 0 ? void 0 : (_details$steps = details.steps) === null || _details$steps === void 0 ? void 0 : _details$steps.some(function (item) {
      return item.cancelled === true;
    });
  };
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var isWebView = useIsWebView();
  var _useState = useState(null),
    userOrdersLength = _useState[0],
    setUserOrdersLength = _useState[1];
  useEffect(function () {
    api__getOrderTrackingList().then(function (orderOrOrders) {
      if (Array.isArray(orderOrOrders)) {
        setUserOrdersLength(orderOrOrders.length);
      } else {
        setUserOrdersLength(1);
      }
    });
    return function () {
      return setUserOrdersLength(null);
    };
  }, []);
  var handleBackFunctionaltyForButton = function handleBackFunctionaltyForButton() {
    if (userOrdersLength === null) {
      return;
    }
    if (userOrdersLength > 1) {
      navigateTo("/tracking-landing");
    }
    if (userOrdersLength <= 1) {
      webview.closeScreen()["catch"](function () {
        if (isWebView) {
          document.location.href = "app://close";
        } else {
          navigateTo("/user/account");
        }
      });
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeskTopBlueMobileWhiteHeader, {
    customBackground: stl.customBackground,
    className2: stl.blueBackground,
    title: t("track_car_order", {
      ns: "web_tracking_finance"
    }),
    hasDeskTopBack: true,
    onClick: handleBackFunctionaltyForButton
  }), /*#__PURE__*/React.createElement(DetailsComponent, {
    details: details,
    onClickPopUp: function onClickPopUp() {
      return 0;
    },
    isFinance: false,
    isCancelled: isCancelled,
    allOfferedDoc: allOfferedDoc,
    onRefreshOrder: onRefreshOrder
  }));
};
export default TrackingCheckoutDetailsComponent;